import { Card, CardContent, Grid, Typography } from "@mui/material"
import ReactApexChart from "react-apexcharts"


export const MonthlyDashboard = (props) => {
    const arrOfStakeholders = props.growerStakeholders?.map((item) => item.stakeholderUrn)
    const filterUniqueGrowers = new Set(arrOfStakeholders);

    const totalGrowers = filterUniqueGrowers?.size
    const totalHit = props.hitStakeholder
    const totalTransporter = props.transporterStakeholders
    const totalLle = props.lleStakeholders

    const remainingGrowers = props.data?.remainingGrowerMbr
    const remainingHit = props.data?.remainigHitMbr
    const remainingTransporter = props.data?.remainigTransporterMbr
    const remainingLle = props.data?.remainigLleMbr

    const options = {
        labels: ["Satisfied", "Not Satisfied"],
        dataLabels: {
            enabled: false,
        },
        chart: {
            type: 'donut',
        },
        legend: {
            floating: false,
            position: "bottom",
            verticalAlign: "center",
            fontSize: "11vw",
            markers: {
                width: 10,
                height: 10,
                radius: 2
            }
        },
    };
    const series = [4, 5];
    const CardSection = (header, value) => {
        return (
            <Grid item xs={4}>
                <Card>
                    <CardContent>
                        <Typography variant='subtitle1'>{header} </Typography>
                        <Typography variant='caption'>{value} </Typography>
                    </CardContent>
                </Card>
            </Grid>
        )
    }
    const DonutSection = (options, series, stakeholderType) => {
        return (
            <Grid item xs={12} lg={3}>
                <Card>
                    <CardContent>
                        <Typography variant='subtitle1'>{stakeholderType}</Typography>
                        <ReactApexChart
                            options={options}
                            series={series}
                            type="donut"
                            height={250}
                            width="100%"
                        />
                    </CardContent>
                </Card>

            </Grid>
        )

    }
    return (
        <>
        <Grid container spacing={1}>
            {CardSection('Remaining Plant Demand(in MT)', props.data?.remainingPlantDemand)}
            {CardSection('Remaining IS Demand(in MT)', props.data?.remainingIsDemand)}
            {CardSection('Total Cost(in INR)', props.data?.totalCost)}
            {CardSection('Total Plant-Demand(in MT)', props.data?.totalPlantDemandAllocated)}
            {CardSection('Total IS-Demand(in MT)', props.data?.totalIsDemandAllocated)}
            </Grid>
            <Grid container spacing={1} mt={2}>
            {DonutSection(options, [totalGrowers - remainingGrowers, remainingGrowers], 'Grower')}
            {DonutSection(options, [totalHit - remainingHit, remainingHit], 'HIT')}
            {DonutSection(options, [totalLle - remainingLle, remainingLle], 'LLE')}
            {DonutSection(options, [totalTransporter - remainingTransporter, remainingTransporter], 'Transporter')}
        </Grid>
        </>
    )

}
